import { makeStyles } from '@material-ui/core/styles'
import criticalIllness from 'src/assets/Buy_Policy_Images/criticalIllness.svg'
import personalAddress from 'src/assets/Buy_Policy_Images/personalAddress.svg'
import wellness from 'src/assets/Buy_Policy_Images/wellness.svg'
import preExisting from 'src/assets/Buy_Policy_Images/preExisting.svg'
import cosmetics from 'src/assets/Buy_Policy_Images/cosmetics.svg'
import selfInflection from 'src/assets/Buy_Policy_Images/selfInflected.svg'
import healthInsurance from 'src/assets/Buy_Policy_Images/healthInsurance.svg'
import keyFeature_1 from 'src/assets/Buy_Policy_Images/keyFeature_1.svg'
import keyFeature_2 from 'src/assets/Buy_Policy_Images/keyFeature_2.svg'
import keyFeature_3 from 'src/assets/Buy_Policy_Images/keyFeature_3.svg'
import keyFeature_4 from 'src/assets/Buy_Policy_Images/keyFeature_4.svg'
import UserDetailsForm from 'src/components/BuyPolicy/insuranceScreens/health/UserDetailsForm'
import HealthInsuranceCarousel from 'src/components/BuyPolicy/insuranceScreens/health/HealthInsuranceCarousel'
import WhyConsiderTrovity from 'src/components/BuyPolicy/common/WhyConsiderTrovity'
import InsuranceCovers from 'src/components/BuyPolicy/common/InsuranceCovers'
import { healthCoveragesList } from 'src/utils/constants/BuyPolicy'
import { useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import React, { useEffect } from 'react'
import { updateOldPolicyId } from 'src/actions'
import { scrollToTop } from 'src/utils/commonMethods'
import { INSURANCE_CONSTANTS } from 'src/utils/constants/BuyPolicyLife'
import { INSURANCE } from 'src/utils/constants/RiskReports'

const UserDetails = () => {
  const classes = useStyles()

  const { search } = useLocation()
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  )
  const oldPolicyId = searchParams?.get('oldPolicyId')

  const dispatch = useDispatch()

  useEffect(() => {
    if (oldPolicyId) {
      dispatch(updateOldPolicyId(oldPolicyId))
    }
    scrollToTop()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className={classes.buyInsuranceMain}>
        <div className={'component-container'}>
          <div className={'component-element'}>
            <div className={classes.buyInsurance}>
              <div className={classes.imageContainer}>
                <HealthInsuranceCarousel title={INSURANCE_CONSTANTS?.HEALTH} />
                <div className={classes.objectsImage}>
                  <iframe
                    src='https://paisaplan.s3.ap-south-1.amazonaws.com/public/animations/buyPolicy/health/data.html'
                    frameBorder='0'
                    allowFullScreen
                    className={classes.iframe}
                  />
                </div>
              </div>
              <div className={classes.formContainer}>
                <UserDetailsForm />
              </div>
            </div>
          </div>
        </div>
        <div className={'component-container'}>
          <div className={'component-element'}>
            <div className={classes.healthInsurance}>
              <div className={classes.healthContainer}>
                <div className={classes.healthContent}>
                  <span className={classes.healthSubTitle}>
                    <b>Health Insurance</b>
                  </span>
                  <span className={classes.healthDescription}>
                    Health Insurance provides financial protection against
                    medical expenses and ensures access to quality healthcare
                    services when needed, giving you peace of mind and the
                    ability to prioritize your well-being.
                  </span>
                </div>
                <div className={classes.needHealthInsuranceContent}>
                  <span className={classes.needHealthSubTitle}>
                    Why do you need Health Insurance?
                  </span>
                  <span className={classes.healthDescription}>
                    Health Insurance is essential to safeguard your health and
                    financial stability. It covers medical expenses,
                    hospitalization costs, and provides access to a wide network
                    of healthcare providers, ensuring timely and comprehensive
                    healthcare services.
                  </span>
                </div>
              </div>
              <div className={classes.healthImageContainer}>
                <img
                  src={healthInsurance}
                  alt=''
                  className={classes.healthInsuranceImage}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`component-container  ${classes.coverageHighlightsComponent}`}
        >
          <InsuranceCovers
            heading={'Coverage Highlights'}
            addOnCoversList={healthCoveragesList}
          />
        </div>
        <div className={'component-container'}>
          <div className={'component-element'}>
            <div className={classes.coveragesSummary}>
              <div className={classes.summaryContainer}>
                <div className={classes.summaryContent}>
                  <p className={classes.contentTitle}>
                    <b>Add-on covers</b>
                  </p>
                  <div className={classes.content}>
                    <div className={classes.contentItem}>
                      <div className={classes.contentCoverageImage}>
                        <img
                          src={criticalIllness}
                          alt=''
                          className={classes.coverages}
                        />
                      </div>
                      <div className={classes.contentItemInput}>
                        <span className={classes.contentItemSubTitle}>
                          <b>Critical Illness</b>
                        </span>
                        <span className={classes.contentItemDescription}>
                          Provides a lump sum payment upon diagnosis of critical
                          illnesses like cancer, heart disease, or stroke.
                        </span>
                      </div>
                    </div>
                    <div className={classes.contentItem}>
                      <div className={classes.contentCoverageImage}>
                        <img
                          src={personalAddress}
                          alt=''
                          className={classes.coverages}
                        />
                      </div>
                      <div className={classes.contentItemInput}>
                        <span className={classes.contentItemSubTitle}>
                          <b>Personal Accident</b>
                        </span>
                        <span className={classes.contentItemDescription}>
                          Offers financial protection in case of accidental
                          injuries or disabilities.
                        </span>
                      </div>
                    </div>
                    <div className={classes.contentItem}>
                      <div className={classes.contentCoverageImage}>
                        <img
                          src={wellness}
                          alt=''
                          className={classes.coverages}
                        />
                      </div>
                      <div className={classes.contentItemInput}>
                        <span className={classes.contentItemSubTitle}>
                          <b>Wellness Programs</b>
                        </span>
                        <span className={classes.contentItemDescription}>
                          Provides access to preventive healthcare services,
                          health check-ups, and discounts on wellness
                          activities.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={classes.summaryContent}>
                  <p className={classes.notCoversContentTitle}>
                    <b>What&apos;s not covered?</b>
                  </p>
                  <div
                    className={`${classes.content} ${classes.notCoversContent}`}
                  >
                    <div className={classes.contentItem}>
                      <div className={classes.contentCoverageImage}>
                        <img
                          src={preExisting}
                          alt=''
                          className={classes.coverages}
                        />
                      </div>
                      <div className={classes.contentItemInput}>
                        <span className={classes.contentItemSubTitle}>
                          <b>Pre-Existing Conditions</b>
                        </span>
                        <span className={classes.contentItemDescription}>
                          Medical conditions that existed prior so purchasing
                          the Policy.
                        </span>
                      </div>
                    </div>
                    <div className={classes.contentItem}>
                      <div className={classes.contentCoverageImage}>
                        <img
                          src={cosmetics}
                          alt=''
                          className={classes.coverages}
                        />
                      </div>
                      <div className={classes.contentItemInput}>
                        <span className={classes.contentItemSubTitle}>
                          <b>Cosmetic procedures</b>
                        </span>
                        <span className={classes.contentItemDescription}>
                          Non-medical procedures performed for aesthetic
                          purposes.
                        </span>
                      </div>
                    </div>
                    <div className={classes.contentItem}>
                      <div className={classes.contentCoverageImage}>
                        <img
                          src={selfInflection}
                          alt=''
                          className={classes.coverages}
                        />
                      </div>
                      <div className={classes.contentItemInput}>
                        <span className={classes.contentItemSubTitle}>
                          <b>Self-Inflicted injuries</b>
                        </span>
                        <span className={classes.contentItemDescription}>
                          Injuries caused intentionally by the insured.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <WhyConsiderTrovity insuranceName={INSURANCE?.HEALTH} />
              </div>
              <span className={classes.headingKeyFeatures}>
                <b>Key Features of Health Insurance</b>
              </span>
              <div className={classes.keyFeaturesContainer}>
                <div className={classes.keyFeatureItemContainer}>
                  <div className={classes.keyFeatureItem}>
                    <div className={classes.keyFeatureImage}>
                      <img src={keyFeature_1} alt='' />
                    </div>
                    <div className={classes.keyFeatureContent}>
                      <span className={classes.keyFeaturesDescription}>
                        Cashless hospitalization and hassle-free claim
                        settlement.
                      </span>
                    </div>
                  </div>
                </div>
                <div className={classes.keyFeatureItemContainer}>
                  <div className={classes.keyFeatureItem}>
                    <div className={classes.keyFeatureImage}>
                      <img src={keyFeature_2} alt='' />
                    </div>
                    <div className={classes.keyFeatureContent}>
                      <span className={classes.keyFeaturesDescription}>
                        Wide network of hospitals and healthcare providers.
                      </span>
                    </div>
                  </div>
                </div>
                <div className={classes.keyFeatureItemContainer}>
                  <div className={classes.keyFeatureItem}>
                    <div className={classes.keyFeatureImage}>
                      <img src={keyFeature_3} alt='' />
                    </div>
                    <div className={classes.keyFeatureContent}>
                      <span className={classes.keyFeaturesDescription}>
                        Option to customize coverage as per your specific needs.
                      </span>
                    </div>
                  </div>
                </div>
                <div className={classes.keyFeatureItemContainer}>
                  <div className={classes.keyFeatureItem}>
                    <div className={classes.keyFeatureImage}>
                      <img src={keyFeature_4} alt='' />
                    </div>
                    <div className={classes.keyFeatureContent}>
                      <span className={classes.keyFeaturesDescription}>
                        Expert guidance and support from Trovity&apos;s team of
                        insurance professionals.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.description}>
                <span className={classes.descriptionContent}>
                  Prioritize your health and protect yourself from unforeseen
                  medical expenses. Choose Trovity InsureTech for comprehensive
                  health insurance coverage. Contact us today for a personalized
                  quote and take a proactive step towards your well-being.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UserDetails

const useStyles = makeStyles({
  buyInsurance: {
    backgroundColor: 'white',
    // padding: '30px 5% 0px 5%',
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // gap: '30px',
    flexDirection: 'column',
    width: '60%',
  },
  formContainer: {
    width: '40%',
  },
  imagesContainer: {
    display: 'flex',
    marginBottom: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '30px',
    flexWrap: 'wrap',
    width: '100%',
  },
  objectsImage: {
    width: '100%',
    // zIndex: 1,
  },
  healthInsurance: {
    backgroundColor: 'white',
    display: 'flex',
    // padding: '30px 90px 30px 90px',
  },
  healthContainer: {
    width: '60%',
  },
  healthContent: {
    padding: '20px 0px 30px 18px',
  },
  healthSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '22px',
    display: 'flex',
    marginBottom: '10px',
  },
  healthDescription: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  needHealthInsuranceContent: {
    border: '1px solid #EF669B',
    borderRadius: '10px',
    padding: '10px 20px',
  },
  needHealthSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '22px',
    color: '#EF669B',
    display: 'flex',
    marginBottom: '10px',
  },
  healthImageContainer: {
    width: '40%',
    display: 'flex',
    justifyContent: 'center',
  },
  healthInsuranceImage: {
    maxWidth: '390px',
    maxHeight: '330px',
    width: '100%',
    height: '100%',
  },
  coverageHighlightsComponent: {
    backgroundColor: '#E5F4F8 !important',
    padding: '0 !important',
  },
  coveragesHighlightsContainer: {
    backgroundColor: '#E5F4F8',
    padding: '10px 0px',
  },
  coveragesHighlights: {
    backgroundColor: '#E5F4F8',
    paddingTop: '10px',
  },
  coveragesSubTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '-15px',
    width: '85%',
    lineHeight: '19.66px',
  },
  coveragesHighlightsTitle: {
    fontSize: '22px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    paddingTop: '10px',
  },
  coverageContainer: {
    padding: '10px 4%',
  },
  coveragesContent: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  coveragesContentItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexBasis: '100%',
    '@media only screen and (min-width: 600px)': {
      flexBasis: '50%',
    },
    '@media only screen and (min-width: 768px)': {
      flexBasis: 'calc(100% / 3)',
    },
  },
  coveragesImage: {
    textAlign: 'center',
  },
  coveragesImageHighlights: {
    width: '130px',
  },
  coverageContentSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  coverageContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    textAlign: 'center',
  },
  coveragesSummary: {
    // padding: '30px 5%',
    fontFamily: 'Roboto',
    fontSize: '15px',
    backgroundColor: 'white',
  },
  summaryContainer: {
    display: 'flex',
    gap: '25px',
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  summaryContent: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    '@media only screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  contentTitle: {
    color: '#4DC3E3',
    fontFamily: 'Roboto',
    fontSize: '22px',
  },
  content: {
    border: '2px solid #4DC3E3',
    borderRadius: '15px',
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    gap: '30px',
    height: '100%',
  },
  contentItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },
  coverages: {
    width: '35px',
  },
  contentItemSubTitle: {
    display: 'flex',
  },
  contentItemDescription: {
    // marginTop: '-13px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '85%',
  },
  notCoversContentTitle: {
    color: '#EF669B',
    fontFamily: 'Roboto',
    fontSize: '22px',
  },
  notCoversContent: {
    border: '2px solid #EF669B',
  },
  notCoversContainerDiv: {
    display: 'flex',
  },
  notCoversContentOtherItem: {
    marginTop: '20px',
    display: 'flex',
  },
  notCoversContentOtherItems: {
    display: 'flex',
    marginTop: '12px',
  },
  trovityLogoContainer: {
    marginTop: '40px',
    display: 'flex',
    '@media (max-width:650px)': {
      flexDirection: 'Column',
    },
    // padding: '20px 50px',
  },
  logoContainerItem: {
    padding: '40px',
    flex: '2',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  trovityLogoImage: {
    width: '422px',
    marginBottom: '20px',
  },
  logoItemImage: {
    flex: '1',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
  },
  logo: {
    width: '250px',
  },
  logoContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    display: 'flex',
    marginBottom: '20px',
  },
  logoContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    opacity: '0.6',
  },
  headingKeyFeatures: {
    fontFamily: 'Roboto',
    fontSize: '22px',
    color: '#4DC3E3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '10px 0',
  },
  keyFeaturesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  keyFeatureContent: {
    width: '85%',
  },
  keyFeatureItemContainer: {
    display: 'flex',
    width: '100%',
    flexBasis: '100%',
    '@media only screen and (min-width: 600px)': {
      flexBasis: '50%',
    },
    '@media only screen and (min-width: 768px)': {
      flexBasis: 'calc(100% / 4)',
    },
  },
  keyFeatureItem: {
    border: '1px solid #4DC3E3',
    borderRadius: '10px',
    padding: '15px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '10px',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  keyFeatureImage: {
    marginBottom: '10px',
  },
  keyFeaturesDescription: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    textAlign: 'center',
  },
  description: {
    textAlign: 'center',
    padding: '4% 11%',
  },
  descriptionContent: {
    fontFamily: 'Roboto',
    fontSize: '16px',
  },
  iframe: {
    width: '100%',
    height: '350px',
  },
  buyInsuranceMain: {
    width: '100%',
  },
  buyHealthInsuranceImage: {
    maxWidth: '300px',
    maxHeight: '75px',
    width: '100%',
    height: '100%',
  },
  claimAndSupportImage: {
    maxWidth: '175px',
    maxHeight: '50px',
    width: '100%',
    height: '100%',
  },
  insuranceMottoImage: {
    maxWidth: '570px',
    maxHeight: '140px',
    width: '100%',
    height: '100%',
  },
})
